import { createReducer } from '@reduxjs/toolkit';
import { SmoEnvironment } from '../../../../Models/Smo/SmoEnvironment';
import WidgetActions from './WidgetActions';
import { WidgetState } from './WidgetState';

const initialState: WidgetState = {
  environment: SmoEnvironment.none
};
export const widgetReducer = createReducer<WidgetState>(initialState, (builder) => {
  builder.addCase(WidgetActions.setSettings, (state, action) => ({ ...state, settings: action.payload }));
  builder.addCase(WidgetActions.setRun, (state, action) => ({ ...state, run: action.payload }));
  builder.addCase(WidgetActions.setEnvironment, (state, action) => ({ ...state, environment: action.payload }));
});
